import React, { memo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { getFAQItemIcon } from 'lib/tours/getTourV2Icons'
import Accordion from 'components/Luxkit/Accordion'

const BulletList = styled(BodyText)`
  list-style: disc;

  > * + li {
    margin-top: ${rem(16)};
  }
`

interface Props {
  FAQItem: Tours.V2OfferFrequentlyAskedQuestion
}

function TourV2FAQItem(props: Props) {
  const { FAQItem } = props
  const { content, title, key } = FAQItem

  const Icon = getFAQItemIcon(key)

  return (
    <Accordion
      heading={title}
      startIcon={<Icon aria-hidden="true" />}
      size="large"
    >
      <BulletList forwardedAs="ul" variant="medium" weight="normal">
        <li>{content}</li>
      </BulletList>
    </Accordion>
  )
}

export default memo(TourV2FAQItem)
